import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const LibraryAddContent = ({type}) => {
  const navigate = useNavigate();
  const accountType = type
  let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
  const redirctToLibrary = (redirect_url) => {
    navigate(redirect_url, { state: { pushonesource: 1 } });
  };
  return (
    <>
      <Col className="right-sidebar custom-change">
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <div className="custom-container">
          <Row>
            <div className="page-top-nav sticky">
              <Row className="justify-content-end align-items-center">
                <Col md={1}>
                  <div className="header-btn-left"></div>
                </Col>
                <Col md={9}>
                  <ul className="tabnav-link">
                    <li className="active active-main">
                      <a href="">Create Your Content</a>
                    </li>

                    <li className="">
                      <a href="">Preview Your Content &amp; Publish</a>
                    </li>
                  </ul>
                </Col>
                <Col md={2}>
                  <div className="header-btn">
                    <Link
                      className="btn btn-primary btn-bordered move-draft"
                      to={ accountType == "vwd" ? "/vwd/library" : "/library-content"}
                    >
                      Cancel
                    </Link>
                  </div>
                </Col>
              </Row>
            </div>
          </Row>

         
        <div className="survey-setup d-flex w-100 library-content-box content-stratch">
          <div className="survey-create-optional text-center">
            <div className="survey-create-optional-box ">
              <h4>How would you like to create your content?</h4>
              <div className="d-flex justify-content-center">
                <div
                  className="survey-optional-box"
                  // onClick={() => redirctToLibrary("/library-create-user")}
                >
                  <div
                    className={"survey-optional-choice"}
                    onClick={() => redirctToLibrary(accountType == "vwd" ? "/vwd/library-create" : "/library-create-user")}
                  >
                    <img src={path_image + "new-content-create.svg"} alt="" />
                  </div>
                  <h5>
                    Create a New content{" "}
                   
                  </h5>
                  <h5 className="optional-discribe">
                    Start from scratch and enter content details manually
                  </h5>
                  <div className="login-validation">
                    {/* {error?.surveyType ? <p>{error?.surveyType} </p> : ""} */}
                  </div>
                </div>
                <div className="survey-optional-box" >
                  <div className="survey-optional-choice" onClick={() => redirctToLibrary(accountType == "vwd" ? "/vwd/library-one-source-content" : "/library-one-source-content")}>
                    <img src={path_image + "use-existing.svg"} alt="" />
                  </div>
                  <h5>
                    Use an Existing One Source content
                    
                  </h5>
                  <h5 className="optional-discribe">
                    Pull details from a previously created content in One Source
                  </h5>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </Col>
    </>
  );
};

export default LibraryAddContent;
